import { ValidationFailure } from "../validation/ValidationResult";

export class ValidationError extends Error {
    public failures: ValidationFailure[];

    public constructor(failures: ValidationFailure[]) {
        super();
        this.failures = failures;
        this.name = "ValidationError";
    }
}
